import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { useEffect, useRef, useState } from 'react'
import BubbleUrl from '../../../assets/Bubble.png'
import SectionWallpaper2URL from '../../../assets/SectionWallpaper2.png'
import SectionWallpaper2_1URL from '../../../assets/SectionWallpaper2_1.png'
import SectionWallpaper2_Full from '../../../assets/SectionWallpaper2_Full.png'
import { discordUrl } from '../../../common/links'

const CardForm = () => (
  <svg
    width="753"
    height="614"
    viewBox="0 0 753 614"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dddd_3783_3436)">
      <path
        d="M700.241 28.1636C701.156 18.1988 692.802 9.84908 682.837 10.7689L66.5294 67.6588C58.2976 68.4187 52 75.3244 52 83.5911V415.898C52 425.153 59.8295 432.478 69.0646 431.862L653.225 392.908C661.072 392.385 667.375 386.237 668.093 378.406L700.241 28.1636Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dddd_3783_3436"
        x="0"
        y="0.699219"
        width="752.31"
        height="613.199"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="9" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3783_3436"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="32" />
        <feGaussianBlur stdDeviation="16" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3783_3436"
          result="effect2_dropShadow_3783_3436"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="73" />
        <feGaussianBlur stdDeviation="22" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3783_3436"
          result="effect3_dropShadow_3783_3436"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="130" />
        <feGaussianBlur stdDeviation="26" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_3783_3436"
          result="effect4_dropShadow_3783_3436"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect4_dropShadow_3783_3436"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
const CardButtonForm = () => {
  const [isHover, setIsHover] = useState(false)

  return (
    <div className="ml-[215px] mt-[25px] ">
      <svg
        width="282"
        height="137"
        // viewBox="0 0 282 137"
        viewBox="0 0 288 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.9961 32.9615C30.8465 25.7141 36.789 20.1303 44.0752 19.732L259.92 7.93501C268.604 7.46038 275.87 14.4469 275.737 23.143L275.23 56.135C275.109 64.0331 268.883 70.4838 260.994 70.8853L41.8603 82.0387C32.5879 82.5107 25.118 74.5311 26.2001 65.3099L29.9961 32.9615Z"
          stroke="#FE902A"
          strokeWidth="2"
          className={`duration-150 ease-in-out ${
            isHover ? '-rotate-3 scale-105 -translate-x-2 translate-y-2 ' : ''
          }`}
        />
        <g filter="url(#filter0_dddd_3845_2503)">
          <path
            d="M29.0029 32.8449C29.91 25.1144 36.2487 19.1583 44.0207 18.7335L259.865 6.9365C269.128 6.43023 276.879 13.8825 276.737 23.1583L276.23 56.1504C276.101 64.575 269.46 71.4557 261.045 71.884L41.9112 83.0375C32.0206 83.5409 24.0527 75.0293 25.2069 65.1934L29.0029 32.8449Z"
            fill={'#FE902A'}
            className="cursor-pointer"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            onClick={() => window.open(discordUrl, '_blank')}
          />

          <mask id="mask-circle">
            <path
              d="M29.0029 32.8449C29.91 25.1144 36.2487 19.1583 44.0207 18.7335L259.865 6.9365C269.128 6.43023 276.879 13.8825 276.737 23.1583L276.23 56.1504C276.101 64.575 269.46 71.4557 261.045 71.884L41.9112 83.0375C32.0206 83.5409 24.0527 75.0293 25.2069 65.1934L29.0029 32.8449Z"
              fill={'white'}
            />
          </mask>

          <circle
            cx="150"
            cy="100"
            r={isHover ? 170 : 0}
            fill="#F27502"
            mask="url(#mask-circle)"
            className="pointer-events-none max-lg:hidden"
            style={{
              transition: 'r 0.5s ease-in-out',
            }}
          />
        </g>
        <g clipPath="url(#clip0_3845_2503)">
          <path
            d="M67.9221 39.8008C66.3688 39.1528 64.7114 38.6932 62.987 38.4571C62.9556 38.4524 62.9249 38.4678 62.9099 38.4969C62.7121 38.8793 62.4957 39.3766 62.3455 39.7668C60.4924 39.5552 58.6582 39.6192 56.8621 39.9583C56.6848 39.571 56.426 39.0988 56.2011 38.7312C56.1841 38.7041 56.1524 38.6909 56.1214 38.6968C54.4186 39.0517 52.7973 39.6257 51.2921 40.3816C51.279 40.3877 51.268 40.3977 51.2609 40.4103C48.3137 45.1644 47.62 49.7255 48.1942 54.1861C48.1968 54.2079 48.2099 54.2284 48.2274 54.2411C50.3315 55.6761 52.3508 56.5214 54.3223 57.0595C54.3538 57.068 54.3865 57.0554 54.4055 57.029C54.8448 56.3829 55.2329 55.7042 55.5611 54.9932C55.5805 54.9516 55.5589 54.9037 55.5158 54.889C54.8548 54.6644 54.2232 54.3843 53.6137 54.0626C53.5654 54.0367 53.5593 53.9692 53.6017 53.9353C53.7241 53.8367 53.8465 53.7343 53.9631 53.6311C53.9842 53.6123 54.0143 53.6074 54.0403 53.6179C58.0282 55.273 62.2779 55.1246 66.0943 53.197C66.1194 53.1837 66.1498 53.1865 66.1731 53.2037C66.2967 53.2985 66.4259 53.3931 66.5558 53.4829C66.6004 53.5138 66.5999 53.5814 66.5537 53.6107C65.9684 53.9808 65.3575 54.2976 64.7129 54.5669C64.6709 54.5845 64.6537 54.6347 64.676 54.6749C65.0605 55.3599 65.495 56.0099 65.9698 56.6242C65.9897 56.6502 66.0241 56.6604 66.0549 56.6498C67.9936 55.9751 69.949 54.991 71.9479 53.4128C71.9654 53.3988 71.9761 53.3784 71.9772 53.3565C72.2966 48.1652 70.8019 43.7177 67.9542 39.8283C67.9471 39.8152 67.9355 39.8061 67.9221 39.8008ZM56.0151 51.1847C54.8333 51.226 53.8216 50.175 53.7751 48.8425C53.7286 47.5101 54.6455 46.3917 55.8463 46.3498C57.0564 46.3075 58.059 47.3684 58.0862 48.692C58.1328 50.0245 57.2157 51.1428 56.0151 51.1847ZM63.985 50.9064C62.8032 50.9477 61.7915 49.8967 61.745 48.5642C61.6985 47.2318 62.6154 46.1134 63.8161 46.0715C65.0262 46.0292 66.0288 47.0901 66.0561 48.4137C66.1027 49.7462 65.1951 50.8641 63.985 50.9064Z"
            fill="white"
            className="pointer-events-none"
          />
        </g>
        <path
          d="M82.5548 55.4079L82.7255 52.1C83.0811 52.1976 83.5027 52.293 84.1403 52.2707C85.4375 52.2254 86.1188 51.5632 86.0689 50.1341L85.6966 39.4706L89.2584 39.3462L89.6254 49.8558C89.7682 53.9453 87.8864 55.53 84.7862 55.6382C83.9727 55.6666 83.1994 55.5836 82.5548 55.4079ZM91.5416 49.1285C91.415 45.5007 93.896 42.7945 97.5898 42.6655C101.306 42.5357 103.947 45.0631 104.074 48.6908C104.2 52.2966 101.742 55.0461 98.0266 55.1758C94.3549 55.3041 91.6676 52.7343 91.5416 49.1285ZM97.9168 52.0318C99.4779 51.9773 100.581 50.794 100.519 49.0131C100.459 47.2982 99.2509 46.1076 97.7118 46.1613C96.1508 46.2159 95.0725 47.4863 95.1324 49.2012C95.1946 50.9821 96.3778 52.0855 97.9168 52.0318ZM107.431 41.4633C106.243 41.5048 105.314 40.7447 105.271 39.5135C105.228 38.2822 106.08 37.46 107.29 37.4178C108.521 37.3748 109.406 38.1363 109.449 39.3676C109.492 40.5988 108.618 41.4218 107.431 41.4633ZM106.195 54.6044L105.778 42.6657L109.186 42.5467L109.603 54.4854L106.195 54.6044ZM112.164 54.396L111.747 42.4573L115.089 42.3406L115.143 43.9016L115.231 43.8985C115.94 42.7511 117.014 41.9872 118.729 41.9273C121.631 41.8259 123.195 43.7525 123.296 46.6548L123.553 53.9983L120.167 54.1165L119.96 48.2021C119.904 46.5971 119.183 45.4996 117.578 45.5556C115.995 45.6109 115.308 46.7356 115.367 48.4066L115.572 54.277L112.164 54.396ZM129.975 47.7864C129.849 44.1586 132.33 41.4523 136.023 41.3233C139.739 41.1936 142.381 43.7209 142.508 47.3487C142.634 50.9545 140.176 53.704 136.46 53.8337C132.788 53.9619 130.101 51.3922 129.975 47.7864ZM136.35 50.6896C137.911 50.6351 139.015 49.4519 138.953 47.671C138.893 45.956 137.685 44.7655 136.145 44.8192C134.584 44.8737 133.506 46.1441 133.566 47.8591C133.628 49.64 134.811 50.7434 136.35 50.6896ZM155.315 40.9359L155.731 52.8746L152.39 52.9913L152.338 51.5182L152.25 51.5212C151.583 52.6012 150.597 53.3401 148.97 53.3969C146.045 53.499 144.459 51.5732 144.358 48.6709L144.101 41.3274L147.509 41.2084L147.732 47.5845C147.788 49.1896 148.442 50.2674 150.003 50.2129C151.52 50.1599 152.184 48.992 152.127 47.365L151.907 41.0549L155.315 40.9359ZM158.284 52.7854L157.867 40.8467L161.209 40.73L161.264 42.313L161.352 42.31C161.923 41.0133 163.354 40.3689 165.289 40.3014L165.205 44.2007C162.386 44.189 161.436 45.3449 161.533 48.1152L161.692 52.6664L158.284 52.7854ZM172.395 52.2927L171.842 36.4623L176.657 36.2942C182.769 36.0807 185.529 39.4625 185.686 43.9478C185.841 48.411 182.794 51.9295 177.078 52.1291L172.395 52.2927ZM176.807 39.9652L175.532 40.0097L175.841 48.8703L177.073 48.8273C180.481 48.7083 182.132 46.8235 182.039 44.1632C181.947 41.5248 180.039 39.8523 176.807 39.9652ZM189.215 38.6073C188.028 38.6488 187.099 37.8888 187.056 36.6575C187.013 35.4263 187.864 34.604 189.074 34.5618C190.305 34.5188 191.19 35.2804 191.233 36.5116C191.276 37.7429 190.402 38.5659 189.215 38.6073ZM187.979 51.7485L187.562 39.8098L190.97 39.6907L191.387 51.6295L187.979 51.7485ZM193.404 51.0967L193.551 48.3839C194.376 48.6853 195.86 48.9417 197.355 48.8895C198.543 48.848 199.305 48.6233 199.282 47.9637C199.264 47.436 198.883 47.2512 196.867 46.8813C194.541 46.4562 193.17 45.6456 193.088 43.315C193.01 41.0724 194.686 39.2748 198.05 39.1573C199.523 39.1059 200.832 39.3904 201.546 39.6736L201.424 43.112C200.534 42.8349 199.338 42.6125 198.106 42.6555C196.941 42.6962 196.421 42.9345 196.44 43.4841C196.459 44.0118 196.795 44.1762 198.719 44.4392C200.998 44.7779 202.437 45.6522 202.508 47.6749C202.595 50.1594 200.928 51.5825 197.564 51.6999C195.805 51.7614 194.363 51.4595 193.404 51.0967ZM212.797 47.4257L213.145 50.4734C212.368 50.8968 211.256 51.2218 210.113 51.2617C206.199 51.3984 203.503 49.2031 203.364 45.2236C203.234 41.5078 205.543 38.8957 209.5 38.7575C210.709 38.7152 211.884 38.9384 212.732 39.283L212.588 42.7001C211.872 42.3729 211.029 42.2042 210.062 42.238C208.039 42.3086 206.894 43.5593 206.956 45.3183C207.019 47.1212 208.288 48.1775 210.245 48.1092C211.102 48.0792 212.041 47.8483 212.797 47.4257ZM214.229 44.8442C214.102 41.2164 216.583 38.5101 220.277 38.3812C223.992 38.2514 226.634 40.7787 226.761 44.4065C226.887 48.0123 224.429 50.7618 220.714 50.8915C217.042 51.0197 214.354 48.45 214.229 44.8442ZM220.604 47.7474C222.165 47.6929 223.268 46.5097 223.206 44.7288C223.146 43.0138 221.938 41.8233 220.399 41.877C218.838 41.9315 217.759 43.2019 217.819 44.9169C217.881 46.6978 219.065 47.8012 220.604 47.7474ZM228.882 50.3201L228.465 38.3814L231.807 38.2647L231.862 39.8477L231.95 39.8447C232.521 38.5479 233.951 37.9036 235.886 37.8361L235.802 41.7354C232.984 41.7237 232.034 42.8796 232.131 45.6499L232.29 50.2011L228.882 50.3201ZM249.344 32.8754L249.928 49.5852L246.564 49.7026L246.513 48.2515L246.447 48.2538C245.78 49.3338 244.463 50.0622 242.836 50.119C239.648 50.2303 237.105 48.0077 236.966 44.0281C236.828 40.0925 239.343 37.7153 242.421 37.6078C243.982 37.5533 245.368 38.1653 246.072 39.3955L246.16 39.3925L245.936 32.9944L249.344 32.8754ZM243.269 41.0784C241.686 41.1337 240.496 42.3639 240.557 44.1229C240.621 45.9478 241.869 47.0049 243.474 46.9488C245.079 46.8928 246.294 45.7497 246.229 43.9028C246.165 42.0559 244.874 41.0223 243.269 41.0784Z"
          fill="white"
          className="pointer-events-none"
        />
        <defs>
          <filter
            id="filter0_dddd_3845_2503"
            x="-42.9043"
            y="0.91217"
            width="324.643"
            height="135.147"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-3" dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3845_2503"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-12" dy="8" />
            <feGaussianBlur stdDeviation="7" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_3845_2503"
              result="effect2_dropShadow_3845_2503"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-26" dy="17" />
            <feGaussianBlur stdDeviation="9.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_3845_2503"
              result="effect3_dropShadow_3845_2503"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-46" dy="31" />
            <feGaussianBlur stdDeviation="11" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_3845_2503"
              result="effect4_dropShadow_3845_2503"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect4_dropShadow_3845_2503"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_3845_2503">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(47.4648 36.1428) rotate(-2)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

const BubbleSection1 = () => {
  const bubbleRef1 = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ repeat: -1 })

      tl.to(bubbleRef1.current, {
        width: 36,
        height: 36,
        left: 10,
        top: 209,
        opacity: 1,
        duration: 1.65,
        ease: 'none',
      })
      tl.to(bubbleRef1.current, {
        width: 18,
        height: 18,
        left: 111,
        top: 39,
        opacity: 0,
        duration: 1.8,
        ease: 'none',
      })
    })

    // Clean up animations on unmount
    return () => ctx.revert()
  }, [])

  return (
    <div className="w-[143px] h-[413px] relative">
      <img
        ref={bubbleRef1}
        className="absolute left-[108px] top-[373px] size-6 opacity-0"
        src={BubbleUrl}
        alt=""
      />
    </div>
  )
}

const BubbleSection2 = () => {
  const bubbleRef2 = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl2 = gsap.timeline({ repeat: -1, delay: 0.35 })

      tl2.to(bubbleRef2.current, {
        left: 10,
        top: 209,
        opacity: 1,
        // delay: 0.35,
        duration: 1.4,
        ease: 'none',
      })
      tl2.to(bubbleRef2.current, {
        width: 18,
        height: 18,
        left: 111,
        top: 39,
        opacity: 0,
        duration: 1.4,
        ease: 'none',
      })
    })

    // Clean up animations on unmount
    return () => ctx.revert()
  }, [])

  return (
    <div className="w-[143px] h-[413px] relative">
      <img
        ref={bubbleRef2}
        className="absolute left-[108px] top-[373px] size-6 opacity-0"
        src={BubbleUrl}
        alt=""
      />
    </div>
  )
}

// const BubbleSection3 = () => {
//   const bubbleRef3 = useRef<HTMLImageElement>(null)

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       const tl3 = gsap.timeline({ repeat: -1, delay: 0.45 })

//       tl3.to(bubbleRef3.current, {
//         width: 44,
//         height: 44,
//         left: 98,
//         top: 185,
//         opacity: 1,
//         // delay: 0.45,
//         duration: 1.5,
//         ease: 'none',
//       })
//       tl3.to(bubbleRef3.current, {
//         width: 18,
//         height: 18,
//         left: 19,
//         top: 39,
//         opacity: 0,
//         duration: 1.6,
//         ease: 'none',
//       })
//     })

//     // Clean up animations on unmount
//     return () => ctx.revert()
//   }, [])

//   return (
//     <div className="w-[143px] h-[413px] relative">
//       <img
//         ref={bubbleRef3}
//         className="absolute left-[16px] top-[373px] size-6 opacity-0"
//         src={BubbleUrl}
//         alt=""
//       />
//     </div>
//   )
// }

const BubbleSection4 = () => {
  const bubbleRef4 = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl4 = gsap.timeline({ repeat: -1, delay: 1.2 })

      tl4.to(bubbleRef4.current, {
        width: 66,
        height: 66,
        left: 87,
        top: 174,
        opacity: 1,
        // delay: 1.2,
        duration: 1.35,
        ease: 'none',
      })
      tl4.to(bubbleRef4.current, {
        width: 18,
        height: 18,
        left: 19,
        top: 39,
        opacity: 0,
        duration: 1.46,
        ease: 'none',
      })
    })

    // Clean up animations on unmount
    return () => ctx.revert()
  }, [])

  return (
    <div className="w-[143px] h-[413px] relative">
      <img
        ref={bubbleRef4}
        className="absolute left-[16px] top-[373px] size-6 opacity-0"
        src={BubbleUrl}
        alt=""
      />
    </div>
  )
}

const BubbleSection5 = () => {
  const bubbleRef5 = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl5 = gsap.timeline({ repeat: -1, delay: 0.2 })

      tl5.to(bubbleRef5.current, {
        width: 58,
        height: 58,
        left: 49,
        top: 174,
        opacity: 1,
        // delay: 0.2,
        duration: 1.2,
        ease: 'none',
      })
      tl5.to(bubbleRef5.current, {
        width: 18,
        height: 18,
        left: 19,
        top: 39,
        opacity: 0,
        duration: 1.8,
        ease: 'none',
      })
    })

    // Clean up animations on unmount
    return () => ctx.revert()
  }, [])

  return (
    <div className="w-[143px] h-[413px] relative">
      <img
        ref={bubbleRef5}
        className="absolute left-[108px] top-[373px] size-6 opacity-0"
        src={BubbleUrl}
        alt=""
      />
    </div>
  )
}

const BubbleSection6 = () => {
  const bubbleRef6 = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl6 = gsap.timeline({ repeat: -1, delay: 0.65 })

      tl6.to(bubbleRef6.current, {
        width: 36,
        height: 36,
        left: 56,
        top: 189,
        opacity: 1,
        // delay: 0.65,
        duration: 1.4,
        ease: 'none',
      })
      tl6.to(bubbleRef6.current, {
        width: 18,
        height: 18,
        left: 19,
        top: 39,
        opacity: 0,
        duration: 1.56,
        ease: 'none',
      })
    })

    // Clean up animations on unmount
    return () => ctx.revert()
  }, [])

  return (
    <div className="w-[143px] h-[413px] relative">
      <img
        ref={bubbleRef6}
        className="absolute left-[108px] top-[373px] size-6 opacity-0"
        src={BubbleUrl}
        alt=""
      />
    </div>
  )
}

export const Section2 = () => {
  const cardRef = useRef<HTMLDivElement>(null)
  const bubblesRef = useRef<HTMLDivElement>(null)
  const backgroundImgRef = useRef<HTMLImageElement>(null)
  const crewImgRef = useRef<HTMLImageElement>(null)

  const [startBubbleAnimation, setStartBubbleAnimation] = useState(false)

  useGSAP(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        scroller: '#scroll-container',
        trigger: backgroundImgRef.current,
        start: '150px center',
        end: '200px 40%',
        scrub: 0.1,
        once: false,
        //markers: true,
        onEnterBack: () => {
          setStartBubbleAnimation(false)

          gsap.to([cardRef.current, bubblesRef.current], {
            opacity: 0,
            duration: 0.4,
          })
        },
      },
      onComplete: () => {
        setStartBubbleAnimation(true)

        gsap.to([cardRef.current, bubblesRef.current], {
          opacity: 1,
          duration: 0.4,
        })
      },
    })
    tl.to(backgroundImgRef.current, {
      top: -76,
    })
    tl.to(
      crewImgRef.current,
      {
        top: 384,
        left: 424,
        width: 1274,
      },
      '<='
    )
  })

  return (
    <div className="relative h-[980px] rounded-2xl max-lg:rounded-b-none overflow-hidden ">
      <img
        className="hidden max-lg:block  size-full object-cover"
        src={SectionWallpaper2_Full}
        alt=""
      />
      <img
        ref={backgroundImgRef}
        className="max-lg:hidden absolute left-0 -top-[6px] w-[2237px] min-w-[2237px] h-[1056px]"
        src={SectionWallpaper2URL}
        alt=""
      />
      <img
        ref={crewImgRef}
        className="max-lg:hidden absolute left-[402px] top-[410px] w-[1318px] "
        src={SectionWallpaper2_1URL}
        alt=""
      />
      {/* Content */}
      <div className="max-lg:hidden absolute left-[120px] -bottom-[80px] max-lg:left-0 max-lg:w-full max-lg:flex max-lg:justify-center">
        <div ref={cardRef} className="opacity-0 relative">
          <CardForm />

          <div className="absolute inset-0 size-full pt-[100px] pl-[100px] 0bg-red-500/50">
            <div className="-rotate-2 w-[507px] flex flex-col gap-4">
              <div className="text-[#0F204B] text-5xl font-bold">
                Pirate Roguelite MMO
              </div>
              <div className="text-[18px] text-black font-medium">
                Feel the thrill of realtime first-person ship combat as you
                battle it out with co-op friends and foes in persistent ocean
                worlds, complete with treasure, dangerous foes, and unbelievable
                ships to own! But keep yer lookout sharp, or Davy Jones will
                have a word with you...
              </div>
              <div className="grow"></div>
              <CardButtonForm />
            </div>
          </div>
        </div>
      </div>
      {/* Bubbles */}
      <div ref={bubblesRef} className="opacity-0 max-lg:hidden">
        {startBubbleAnimation && (
          <>
            <div className="absolute right-[62px] bottom-[277px]">
              <BubbleSection6 />
            </div>
            <div className="absolute right-[461px] bottom-[305px]">
              <BubbleSection5 />
            </div>
            <div className="absolute right-[101px] bottom-[333px]">
              <BubbleSection5 />
            </div>
            <div className="absolute right-[333px] bottom-[373px]">
              <BubbleSection5 />
            </div>
            <div className="absolute right-[175px] bottom-[373px]">
              <BubbleSection4 />
            </div>
            <div className="absolute right-[27px] bottom-[277px]">
              <BubbleSection4 />
            </div>
            <div className="absolute right-[501px] bottom-[277px]">
              <BubbleSection4 />
            </div>
            <div className="absolute right-[323px] bottom-[251px]">
              <BubbleSection2 />
            </div>
            <div className="absolute right-[391px] bottom-[333px]">
              <BubbleSection1 />
            </div>
          </>
        )}
      </div>

      {/* Mobile Content */}
      <div className="hidden max-lg:block absolute size-full inset-0">
        <div className="px-6 pb-20 size-full flex flex-col justify-end">
          <div className="relative px-6 pt-5 pb-16 flex flex-col gap-4 bg-white rounded-xl ">
            <div className="text-[#0F204B] text-5xl font-bold">
              Pirate Roguelite MMO
            </div>
            <div className="text-[18px] text-black font-medium">
              Feel the thrill of realtime first-person ship combat as you battle
              it out with co-op friends and foes in persistent ocean worlds,
              complete with treasure, dangerous foes, and unbelievable ships to
              own! But keep yer lookout sharp, or Davy Jones will have a word
              with you...
            </div>
            <div className="absolute -bottom-[90px] right-4">
              <CardButtonForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
